module.exports = __webpack_public_path__ + "static/media/ST10.052d0661.mp3";